module.exports = __webpack_public_path__ + "static/img/AmwayIcons.dff48a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/relayevent/font/AmwayIcons.svg?5v2gxx
// module id = OF7m
// module chunks = 0